var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tour',{attrs:{"name":_vm.name,"steps":_vm.tourSteps,"options":{ highlight: true, debug: false },"callbacks":{ onFinish: _vm.onTourFinished, onSkip: _vm.onSkipTour }}})
}
var staticRenderFns = []

export { render, staticRenderFns }